const customergroups = {
	title: "Kundegrupper",
	new_customergroup: "Ny kundegruppe",
	edit_customergroup: "Rediger: {name}",
	view_customergroup: "Vis: {name}",
	list_title: "Kundegrupper",
	list_subtitle: "Håndter kundegrupper",
	create_title: "Opprett gruppe",
	update_title: "Oppdater gruppe",
	id: "ID",
	name: "Navn",
	status: "Status",
	created_by: "Opprettet av",
};
export default customergroups;